export default __webpack_public_path__ + "static/media/404.f07e5c1c.jpg";